<template>
  <div class="theme">
    <div class="title">新建专题</div>
    <el-card style="marginTop:10px;">
      <p class="title">新建专题</p>
      <p class="mess">基础信息</p>

      <el-form :model="userForm"
               ref="userForm"
               :rules="rules"
               label-width="100px"
               style="marginTop:16px"
               class="userForm">
        <el-form-item label="专题标题："
                      prop="title">
          <el-input v-model="userForm.title"
                    placeholder="请输入笔记标题"></el-input>
        </el-form-item>

        <el-form-item label="主图："
                      prop="chief_img">
          <el-upload class="avatar-uploader"
                     :action="imgUploadUrl"
                     list-type="picture-card"
                     :file-list="userForm.chief_img"
                     :headers="uploadHeaders"
                     :on-success="handleUploadSuccess"
                     :before-upload="handleBeforeUpload"
                     :show-file-list="false">
            <img v-if="imageUrl"
                 :src="imageUrl"
                 class="avatar">
            <i v-else
               class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="背景图："
                      prop="background_imgs">
          <el-upload class="avatar-uploader"
                     :action="imgUploadUrl"
                     list-type="picture-card"
                     :file-list="userForm.background_imgs"
                     :headers="uploadHeaders"
                     :on-success="handleBackUploadSuccess"
                     :before-upload="handleBackBeforeUpload"
                     :on-exceed="handleExceed"
                     drag
                     :limit="limit"
                     :show-file-list="true">

            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

        </el-form-item>

        <el-form-item label="副图："
                      prop="assit_img">
          <el-upload class="avatar-uploader"
                     :action="imgUploadUrl"
                     :limit="assitLimit"
                     list-type="picture-card"
                     :file-list="userForm.assit_img"
                     :headers="uploadHeaders"
                     :on-success="handleAssitUploadSuccess"
                     drag
                     :show-file-list="true"
                     :on-exceed="handleAssitExceed">

            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="参数一："
                      prop="extend_param_one">
          <el-input v-model="userForm.extend_param_one"
                    placeholder="参数一"></el-input>
        </el-form-item>
        <el-form-item label="参数二："
                      prop="extend_param_two">
          <el-input v-model="userForm.extend_param_two"
                    placeholder="参数一"></el-input>
        </el-form-item>
        <el-form-item label="参数三："
                      prop="extend_param_three">
          <el-input v-model="userForm.extend_param_three"
                    placeholder="参数一"></el-input>
        </el-form-item>
        <el-form-item label="有效期："
                      prop="datetime">
          <el-date-picker :default-time="['00:00:00', '23:59:59']"
                          format="yyyy-MM-dd HH:mm"
                          class="datetime"
                          v-model="userForm.datetime"
                          type="datetimerange"
                          range-separator="至"
                          value-format="timestamp"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="院校："
                      prop="page_college_codes">
          <div class="tag-wrap">
            <el-tag class="subject-item"
                    size="medium"
                    :key="item.id"
                    v-for="item in colleges"
                    closable
                    :disable-transitions="false"
                    @close="handleCollegeRemove(item)">
              {{ `${item.name}` }}
            </el-tag>
            <el-button type="text"
                       @click="handleCollegeChoose">选择院校</el-button>
          </div>
        </el-form-item>
        <el-form-item label="专业："
                      prop="majors">
          <div class="tag-wrap">
            <el-tag class="subject-item"
                    size="medium"
                    :key="item.id"
                    v-for="item in majors"
                    closable
                    :disable-transitions="false"
                    @close="handleMajorRemove(item)">
              {{ `${item.name}/${item.code}` }}
            </el-tag>
            <el-button type="text"
                       @click="handleMajorChoose">选择专业</el-button>
          </div>
        </el-form-item>

        <el-form-item label="科目："
                      prop="majors">
          <div class="tag-wrap">
            <el-tag class="subject-item"
                    size="medium"
                    :key="item.id"
                    v-for="item in subjects"
                    closable
                    :disable-transitions="false"
                    @close="handleSubjectRemove(item)">
              {{
                  item.college_name
                    ? `${item.college_name}-${item.name}`
                    : item.name
                }}
            </el-tag>
            <el-button type="text"
                       @click="handleSubjectChoose">选择科目</el-button>
          </div>
        </el-form-item>

        <!-- <p class="mess">添加学长</p>
        <el-form-item label="选择学长："
                      prop="extend_param_one"
                      style="marginTop:16px">
          <div class="chooseSenior">
            <div v-for="(item,index) in chooseSenior"
                 :key="index">
              <p class="typeName"><span style="marginRight:10px;width:60px">分类名称</span><el-input placeholder="请输入"
                          style="width:181px"
                          v-model="item.category_name"></el-input></p>
              <p class="typeName"><span style="marginRight:10px;width:60px">筛选项</span>
                <el-select v-model="item.chooseItem"
                           placeholder="请选择学长类型"
                           multiple
                           style="width: 93%">
                  <el-option v-for="item in item.filterItem"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </p>
              <p class="typeName"><span style="marginRight:10px;width:60px">内部备注</span><el-input placeholder="请输入"
                          style="width: 93%"
                          v-model="item.senior_inner_remark"></el-input></p>
            </div>
            <div class="addType"
                 @click="handleAddType()">+添加分类</div>
          </div>
        </el-form-item> -->
        <el-form-item label="详情图："
                      prop="detail_imgs">
          <el-upload class="avatar-uploader"
                     :action="imgUploadUrl"
                     :limit="detailLimit"
                     list-type="picture-card"
                     :file-list="userForm.detail_imgs"
                     :headers="uploadHeaders"
                     :on-success="handleDetailUploadSuccess"
                     drag
                     :show-file-list="true"
                     :on-exceed="handleDetailExceed">

            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="footer">
        <div class="cancle">取消</div>
        <div class="confirm"
             @click="submit()">确定</div>
      </div>
    </el-card>
    <CollegeChoose :visible="collegeChooseDialog"
                   :colleges="colleges"
                   @close="collegeChooseDialog = false"
                   @submit="saveCollege"></CollegeChoose>
    <MajorChoose :visible="majorChooseDialog"
                 :majors="majors"
                 @close="majorChooseDialog = false"
                 @submit="saveMajor"></MajorChoose>
    <SubjectChoose :visible="subjectChooseDialog"
                   :subjects="subjects"
                   @close="subjectChooseDialog = false"
                   @submit="saveSubject"></SubjectChoose>
  </div>
</template>
<script>
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import { themePageCreate } from '@/api/senior'
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
} from '@/api/common'
import CollegeChoose from '@/components/dialog/college/CollegeChoose'
import SubjectChoose from '@/components/dialog/subject/SubjectChoose'
import MajorChoose from '@/components/dialog/major/MajorChoose'
export default {
  components: { CollegeChoose, MajorChoose, SubjectChoose },
  data() {
    return {
      subjectChooseDialog: false,
      majorChooseDialog: false,
      collegeChooseDialog: false,
      limit: 3,
      assitLimit: 1,
      detailLimit: 9,
      userForm: {
        chief_img: [],
        background_imgs: [],
        assit_img: [],
        detail_imgs: [],
        extend_param_one: '',
        extend_param_two: '',
      },
      chooseSenior: [
        {
          category_name: '',
          filterItem: [],
          chooseItem: [],
          senior_inner_remark: '',
        },
      ],
      imageUrl: '',
      assitUrl: '',
      subjects: [],
      majors: [],
      colleges: [],
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      rules: {
        title: [{ required: true, message: '请输入笔记专题', trigger: 'blur' }],
        // datetime: [
        //   {
        //     required: true,
        //     message: '请选择有效期',
        //     trigger: 'change',
        //     validator: (rule, value, callback) => {
        //       if (!this.userForm.datetime) {
        //         return callback(new Error(rule.message))
        //       } else {
        //         callback()
        //       }
        //     },
        //   },
        // ],
        chief_img: [
          {
            required: true,
            message: '请上传主图',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.userForm.chief_img.length) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            },
          },
        ],
        background_imgs: [
          {
            required: true,
            message: '请上传背景图',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.userForm.background_imgs.length) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            },
          },
        ],
        detail_imgs: [
          {
            required: true,
            message: '请上传详情图',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.userForm.detail_imgs.length) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            },
          },
        ],
      },
    }
  },
  created() {
    this.$store.dispatch('getAllColleges')
  },
  methods: {
    handleCollegeChoose() {
      this.collegeChooseDialog = true
    },
    saveCollege({ colleges }) {
      this.colleges = colleges
    },
    handleMajorChoose() {
      this.majorChooseDialog = true
    },
    handleSubjectChoose() {
      this.subjectChooseDialog = true
    },
    handleSubjectRemove(item) {
      this.subjects = this.subjects.filter((v) => v.id !== item.id)
    },
    saveMajor({ majors }) {
      this.majors = majors
    },
    saveSubject({ subjects }) {
      this.subjects = subjects
    },
    handleCollegeRemove(item) {
      this.colleges = this.colleges.filter((v) => v.id !== item.id)
    },
    handleMajorRemove(item) {
      this.majors = this.majors.filter((v) => v.id !== item.id)
    },
    handleAddType() {
      this.chooseSenior.push({
        category_name: '',
        filterItem: [],
        senior_inner_remark: '',
        chooseItem: [],
      })
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.userForm.chief_img.push({ url: res.data.url, name: '' })
        this.imageUrl = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload() {},
    handleBackUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.userForm.background_imgs.push({ url: res.data.url, name: '' })
      } else {
        this.$message.error(res.error)
      }
    },
    handleAssitUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.userForm.assit_img.push({ url: res.data.url, name: '' })
        console.log('44', this.userForm)
      } else {
        this.$message.error(res.error)
      }
    },
    handleDetailUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.userForm.detail_imgs.push({ url: res.data.url, name: '' })
      } else {
        this.$message.error(res.error)
      }
    },
    handleBackBeforeUpload(file) {
      console.log('file', file)
    },
    // 超出上传数量的处理
    handleExceed(files, fileList) {
      // 提示用户超出限制
      this.$message.error(`最多只能上传${this.limit}张图片`)
      // 可选：清空超出的文件（防止用户重复选择）
      return false
    },
    handleDetailExceed(files, fileList) {
      // 提示用户超出限制
      this.$message.error(`最多只能上传${this.detailLimit}张图片`)
      // 可选：清空超出的文件（防止用户重复选择）
      return false
    },
    handleAssitExceed(files, fileList) {
      // 提示用户超出限制
      this.$message.error(`最多只能上传${this.assitLimit}张图片`)
      // 可选：清空超出的文件（防止用户重复选择）
      return false
    },
    getAcademy(college_code, major_code) {
      academyList({
        college_code: college_code,
        isPaging: 0,
        major_code: major_code,
      }).then((res) => {
        this.academyList = res.list || []
        console.log('academyList', this.academyList)
      })
    },
    collegeChange(e) {
      this.userForm.page_college_names = this.$store.state.collegeList.find(
        (item) => {
          return item.code === e //筛选出匹配数据
        }
      ).name
    },
    submit() {
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          let data = {
            title: this.userForm.title,
            chief_img: this.imageUrl,
            background_imgs: this.userForm.background_imgs,
          }
          // 背景图片
          let backImg = []
          this.userForm.background_imgs.map((item) => {
            backImg.push(item.url)
          })
          data.background_imgs = backImg.join(',')
          //副图
          let assitImg = []
          if (this.userForm.assit_img.length > 0) {
            this.userForm.assit_img.map((item) => {
              assitImg.push(item.url)
            })
            data.assist_img = assitImg.join(',')
          }
          console.log('this.userForm.assit_img', this.userForm.assit_img)

          if (this.userForm.extend_param_one != '') {
            data.extend_param_one = this.userForm.extend_param_one
          }
          if (this.userForm.extend_param_two != '') {
            data.extend_param_two = this.userForm.extend_param_two
          }
          if (this.userForm.extend_param_three != '') {
            data.extend_param_three = this.userForm.extend_param_three
          }
          // 有效期
          data.start_time = this.userForm.datetime[0]
          data.end_time = this.userForm.datetime[1]
          // 院校科目专业
          let collegeName = []
          let collegeCode = []
          let majorName = []
          let majorCode = []
          let subjectName = []
          let subjectCode = []
          if (this.colleges.length > 0) {
            this.colleges.map((item) => {
              collegeName.push(item.name)
              collegeCode.push(item.code)
            })
            data.page_college_codes = collegeCode.join(',')
            data.page_college_names = collegeName.join(',')
          }
          if (this.majors.length > 0) {
            this.majors.map((item) => {
              majorName.push(item.name)
              majorCode.push(item.code)
            })
            data.page_major_codes = majorCode.join(',')
            data.page_major_names = majorName.join(',')
          }
          if (this.subjects.length > 0) {
            this.subjects.map((item) => {
              subjectName.push(item.name)
              subjectCode.push(item.code)
            })
            data.page_subject_codes = subjectCode.join(',')
            data.page_subject_names = subjectName.join(',')
          }
          // 详情图
          let detailImg = []
          if (this.userForm.detail_imgs.length > 0) {
            this.userForm.detail_imgs.map((item) => {
              detailImg.push(item.url)
            })
          }
          data.detail_imgs = detailImg.join(',')
          console.log('detail', data)

          themePageCreate(data).then((res) => {
            this.$router.push(`/senior/topicMangement`)
            this.$message.success('操作成功')
          })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-upload-dragger {
  width: 90px;
  height: 90px;
}
::v-deep .el-upload--picture-card {
  width: 90px;
  height: 90px;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 90px !important;
  height: 90px !important;
}
.theme {
  padding: 16px;
  .title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #303133;
  }
  .mess {
    margin-top: 14px;
    padding-left: 17px;
    width: 100%;
    height: 51px;
    font-weight: 700;
    line-height: 51px;
    background: #f5f5f5;
    border-radius: 0px 0px 0px 0px;
  }
  .avatar {
    width: 87px;
    height: 87px;
  }
  .chooseSenior {
    padding: 14px;
    width: 100%;
    min-height: 220px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdfe6;
    .typeName {
      font-size: 14px;
      color: #606266;
      padding: 14px;
      display: flex;
      align-items: center;
      height: 51px;
      background: #f5f5f5;
    }
  }
  .tag-wrap {
    display: flex;
    flex-wrap: wrap;
  }
  .subject-item,
  .teacher-item {
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .addType {
    margin-top: 16px;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: #409eff;
    width: 78px;
    height: 32px;
    line-height: 32px;
    background: rgba(64, 158, 255, 0.2);
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #409eff;
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    .cancle {
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      color: #909399;
      width: 56px;
      height: 36px;
      line-height: 36px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dcdfe6;
      margin-right: 16px;
    }
    .confirm {
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      width: 56px;
      height: 36px;
      line-height: 36px;
      background: #409eff;
      border-radius: 4px 4px 4px 4px;
    }
  }
}
</style>